import { render, staticRenderFns } from "./bnbCollectionTrx.vue?vue&type=template&id=b185f6ec&scoped=true"
import script from "./bnbCollectionTrx.vue?vue&type=script&lang=js"
export * from "./bnbCollectionTrx.vue?vue&type=script&lang=js"
import style0 from "./bnbCollectionTrx.vue?vue&type=style&index=0&id=b185f6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b185f6ec",
  null
  
)

export default component.exports